export class OrderHelper {

  static orderStatuses: { [key: string]: any; } = {
    pending: {
      slug: 'pending',
      formatted: 'En attente de paiement'
    },
    confirmed: {
      slug: 'confirmed',
      formatted: 'Confirmée'
    },
    preparing: {
      slug: 'preparing',
      formatted: 'Préparation'
    },
    delivering: {
      slug: 'delivering',
      formatted: 'Livraison'
    },
    done: {
      slug: 'done',
      formatted: 'Terminée'
    }
  };
  static orderStatusTimeline = ['pending', 'confirmed', 'preparing', 'delivering', 'done'];

  static getNextTimelineStatuses(status: string): string[] {
    const index = OrderHelper.orderStatusTimeline.indexOf(status);
    const statuses = [];
    let i = 0;
    for (const s of OrderHelper.orderStatusTimeline) {
      if (s !== status && i > index) {
        statuses.push(s);
      }
      ++i;
    }
    return statuses;
  }

  static getPreviousTimelineStatuses(status: string): string[] {
    const index = OrderHelper.orderStatusTimeline.indexOf(status);
    const statuses = [];
    let i = 0;
    for (const s of OrderHelper.orderStatusTimeline) {
      if (s !== status && i < index) {
        statuses.push(s);
      }
      ++i;
    }
    return statuses;
  }

}
